// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
//
import Button from 'components/common/Button';
import AnchorLink from 'react-anchor-link-smooth-scroll';

const Container = styled.div`
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-bottom: 1px solid #e1eaf2;
  padding-bottom: 20px;
`;

const Jumbotron = () => (
  <Container>
    <div>
      <h1>
        We are your partners in <br />
        value-based reimbursement.
      </h1>
      <p style={{ marginTop: 20 }}>
        We offer clarity by providing insightful market and business intelligence <br />
        solutions using your most valuable asset-claims data.
      </p>
      <AnchorLink href="#plans">
        <Button style={{ marginTop: 40, height: 30 }} type="primary" className="round-button">
          LEARN MORE
        </Button>
      </AnchorLink>
    </div>
  </Container>
);

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/routes/app-home/Jumbotron/index.js